import React, { useState } from 'react';
import { Grid, Box, Container, Skeleton, Typography } from '@mui/material';
import Sidebar from './Sidebar';
import MainSection from './MainSection';
import { useContent } from "../../hooks/useExplore";

function Content() {
    const { content, loading, error } = useContent();
    const [selectedLevels, setSelectedLevels] = useState([]);
    const [selectedDomains, setSelectedDomains] = useState([]);
    const [selectedType, setSelectedType] = useState([]);

    // Update the filteredContent logic
    const filteredContent = content.filter(
        (data) =>
            (selectedLevels.length === 0 || selectedLevels.includes(data.level)) &&
            (selectedDomains.length === 0 || selectedDomains.includes(data.domain)) &&
            (selectedType.length === 0 || selectedType.includes(data.type))
    );

    return (
        <Container maxWidth="lg">
            <Box sx={{ py: 4, maxWidth: '100%', overflowX: 'hidden' }}>
                <Grid container spacing={2} sx={{ height: 'auto' }}>
                    {/* Sidebar */}
                    <Grid item xs={12} sm={3}>
                        <Sidebar
                            selectedLevels={selectedLevels}
                            setSelectedLevels={setSelectedLevels}
                            selectedDomains={selectedDomains}
                            setSelectedDomains={setSelectedDomains}
                            selectedType={selectedType}
                            setSelectedType={setSelectedType}
                        />

                    </Grid>

                    {/* Main Section */}
                    <Grid item xs={12} sm={9}>
                        {loading ? (
                            <Grid container spacing={2}>
                                {[...Array(3)].map((_, i) => (
                                    <Grid item xs={12} sm={6} md={4} key={i}>
                                        <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2, mb: 1 }} />
                                        <Skeleton variant="text" height={30} width="90%" />
                                        <Skeleton variant="text" height={20} width="70%" />
                                        <Skeleton variant="text" height={20} width="50%" />
                                    </Grid>
                                ))}
                            </Grid>
                        ) : error ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '50vh',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography color="error" variant="h6">
                                    {error}
                                </Typography>
                            </Box>
                        ) : filteredContent.length > 0 ? (
                            <MainSection content={filteredContent} />
                        ) : (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '50vh',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="body1" color="text.secondary">
                                    No content available.
                                </Typography>
                            </Box>
                        )}
                    </Grid>

                </Grid>
            </Box>
        </Container>
    );
}

export default Content;
